export default import.meta.ROLLUP_FILE_URL_OxgPY7jd89vmgHQlmb5h_Q;